const generateTaskToDeleteProduct = (
  product,
  storeIdToCheck,
  storeIdToDelete,
  storeViewCode
) => {
  const {
    name,
    sku,
    extension_attributes: {website_ids}
  } = product;

  const isInBothStoreViews = website_ids.includes(storeIdToCheck);

  const task = {
    body: isInBothStoreViews
      ? {extension_attributes: {
        website_ids: website_ids.filter((id) => id !== storeIdToDelete)
      }}
      : {},
    name,
    sku,
    requestType: isInBothStoreViews
      ? 'UPDATE_PRODUCT_TO_DELETE_STOREVIEW'
      : 'DELETE_PRODUCT',
    storeViewCode
  };

  return task;
};

export {
  generateTaskToDeleteProduct
};
